import clsx from "clsx";
import { useEffect, useState } from "react";

import { BackToTopArrowImg } from "@/assets/common";
import { scrollToTop } from "@/hooks/useSmoothScroll";

// White 44px square with an up arrow, per the v2 design's floating widgets.
export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when scrolled down 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <button
      onClick={() => scrollToTop()}
      aria-label="Back to top"
      className={clsx(
        "fixed bottom-[131px] right-10 z-50",
        "flex items-center justify-center",
        "size-[44px] rounded-[4px] bg-white",
        "hover:opacity-85 active:opacity-75 transition-opacity",
      )}
    >
      <img src={BackToTopArrowImg} alt="" className="size-[24px] rotate-180" />
    </button>
  );
}
